import styled from "styled-components";


export const KeywordWrapper = styled.div`
  font-family: inherit;
  

  text-align: left;
  width: 48%;
  margin-bottom: 20px;
  margin-top: 20px;
`;
export const TopicText = styled.div`
  color: rgba(45, 137, 85, 1);
  font-family: inherit;
  font-size: 18px;
  font-weight: 700;
  // margin-left:8px;
`;


export const SubLabel = styled.span`
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 10px;
  // margin-left: 8px;

  color: rgba(99, 99, 99, 1);

  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.15px;
`;

export const ErrorMessage = styled.div`
  padding: 2px 10px;
  color: #d74748;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
`;

export const Label = styled.span`
  color: #000000;
  margin-left: 8px;

  font-family: inherit;
  font-size: 16px;
  font-weight: 500;

  & > span {
    color: #fc6758;
  }
`;

export const ShowAlertWrapper = styled.div`
  margin-bottom: 90px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width:80%;
  margin-left:auto;
  margin-right:auto;
  overflow: scroll !important;
`;

export const ResetThresholdDiv = styled.div`

    display: grid;
    grid-template-columns: 60% 37%;

    & > .child1 {
      display: grid;
      grid-template-columns: 55% 30% 10%;
      font-size: 15px;
      font-weight: 500;
      /* line-height: 29px; */
      color: rgba(42, 41, 41, 1);
      align-items: center;
      height: 19px;
    }
`
;
export const FlexAlertWrapper = styled.div` 
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content:space-between;
  
    display: grid;
    grid-template-columns: 1fr 1fr;
`;
export const InfoWrapper = styled.div`
  & .infoIcon {
    margintop: 2px;
    color: #222;
    border-radius: 50%;
    border: 2.5px solid #222;
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  font-family: inherit;
    font-size: 10px;
    font-weight: 600;

    cursor: pointer;
    position: relative;

    &:hover {
      & .infoText {
        display: unset;
      }
    }

    & .infoText {
      display: none;
      color: rgb(255, 255, 255);
      position: absolute;
      right: -25px;
      top: 30px;
      min-width: 205px;
      max-width: 300px;
      min-height: 30px;
      background: linear-gradient(95.02deg, rgb(160, 217, 37) -65.35%, rgb(0, 106, 104) 100%);
      padding: 10px;
      border-radius: 8px;
      z-index: 100;
  font-family: inherit;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      opacity: 0.9;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px 0px;
      backdrop-filter: blur(40px);

      &:before {
        content: "";
        position: absolute;
        /* backdrop-filter: blur(15px); */
        right: 22px;
        bottom: 53px;
        width: 0px;
        height: 0px;
        border-width: 10px 10px 15px;
        border-style: solid;
        border-color: transparent transparent rgb(0, 106, 104);
        border-image: initial;
        opacity: 0.9;
        z-index: 11;
      }
      & > ul {
        & > li {
          white-space: nowrap;
          line-height: 15px;
          margin-left: -25px;
        }
      }
    }
  }
`;
export const TitleInput = styled.input`

    font-size: 16px;
    font-weight: 500;
    padding: 15px 18px;
    height: 22px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid ${(props) => (props.isError ? 'red' : 'rgb(162, 162, 162)')};
    position: relative;
    width: 92%;
  font-family: inherit;
    
`;

export const LabelStyle = styled.span`
  color: rgb(0, 0, 0);
  // margin-left: 8px;
  font-family: inherit;
  font-size:16px;
  font-weight: 500;
  text-transform: capitalize;

  & > .mandatory{
      color: red;
      margin-left: 2px;
  }
`;
export const AlertUserList = styled.div`
    font-size: 16px;
    font-weight: 500;
    padding: 7px 18px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid rgb(162, 162, 162);
    position: relative;
  font-family: inherit;
    margin-top: 16px;
    min-height:38px;
`;

export const ThresHoldInput = styled.input`
    height: 30px;
    width: 95.2%;
    border: 1px solid ${(props) => (props.isError ? 'red' : 'rgb(162, 162, 162)')};
    font-size: 16px;
    border-radius: 8px;
    padding: 11px;
    outline: none;         
    &:focus {
        outline: none;    
        border-color: rgb(162, 162, 162);
        box-shadow: none;
    }
`;

export const LabelParaStyle = styled.span`
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 10px;
  // margin-left: 8px;
  color: rgb(99, 99, 99);
  font-family: inherit;
  font-size: 13px;
  font-weight: 400
`;

export const SwitchTabWrapper = styled.div`

    display: flex;
    justify-content: start;
    flex-direction:row;

    & > .chatter_switch_tab {
      border-radius:8px 0px 0px 8px;
      width: 130px;
      padding: 10px;
      border: 1px solid rgba(162, 162, 162, 1);
    }

    & > .topic_switch_tab {
      border-radius:0px 8px 8px 0px;
      width: 130px;
      padding: 10px;
      border: 1px solid rgba(162, 162, 162, 1);
      border-left:none;
    }

    & > .active {
      background: rgba(53, 60, 247, 1);
      color:white;
    }

`;

export const SaveButton = styled.button`
    height: 56px;
    width: 121px;
    border: 1px solid rgba(162, 162, 162, 0.6);
    color: rgba(99, 99, 99, 1);
    background: white;
    font-size: 17px;
    border-radius: 50px;
    filter: drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 4px);

`;

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const StyledCheckbox = styled.span`
  width: 19px;
  height: 19px;
  background: ${({ checked, disabled }) =>
        disabled ? '#ccc' : checked ? 'green' : '#eee'};
  border: 1px solid #aaa;
  border-radius: 4px;
  transition: all 150ms;
  position: relative;
  margin-bottom:0px !important;

  &::after {
    content: '';
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    position: absolute;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
export const ChannelTabWrapper = styled.div`
    width: 198px;
    height: 31px;
    display: grid;
    border: 1px solid rgba(181, 181, 181, 1);
    border-radius: 4px;
    grid-template-columns: 30px 1fr 30px;
    align-items: center;
    padding: 8px;
    align-content: space-evenly;

    & > input {
    
    width:  19px;
    height: 19px;
    }

    & > .addIcon {
      height: 22px;
      width: 25px;
      cursor:pointer;

      & > svg {
      
      height: 22px;
      }

    }

    & > .channelName {
  font-family: inherit;
        font-weight: 600;
        font-size: 14px;
        text-transform: capitalize;
        color:rgba(42, 41, 41, 1);
    }
`;

export const GridChannelWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 12px;
    width:97%;
`;

export const AlertSaveButtonWrapper = styled.div`

    text-align: left;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;


`;

export const ChannelGrpLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & > .title {
    color:rgba(42, 41, 41, 1);
  font-family: inherit;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-transform: capitalize;
  
  }

  & > .desc{
  font-family: inherit;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0%;
  text-transform: capitalize;

  }

`;

export const ApplyBtnWrapper = styled.div`

    display: flex;
    margin-bottom: 20px;
    gap: 25px;
    justify-content: end;
    margin-top: 25px;

    & > .cancelBtn {    
      height: 35px;
      width: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
  font-family: inherit;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0%;
      text-transform: capitalize;
      cursor:pointer;
    }

    & > .applyBtn {
      height: 35px;
      width: 90px;
      color: rgba(255, 255, 255, 1);
      background: linear-gradient(180deg, #0B7263 0%, #5AA942 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
  font-family: inherit;
      font-weight: 600;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      text-transform: capitalize;
      cursor:pointer;
    }
`;

// export const SwitchTab = styled.div`
//     width: 130px;
//     padding: 10px;
//     border: 1px solid rgba(162, 162, 162, 1);



// `;